import React from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { PreloadedImage } from 'src/common-ui/preloaded-image/preloaded-image.component';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export function CustomSelectItemComponent({ item, isSelected, isLast, handleItemClicked, closeDropdown, onDelete, canDelete = false, }) {
    const handleDeleteClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (onDelete)
            onDelete(item, event);
    };
    return (React.createElement("div", { className: "option" },
        React.createElement("div", { "data-testid": `custom-select-item-${item.value}`, className: `custom-select-item ${isSelected ? 'selected' : ''}`, onClick: () => {
                handleItemClicked();
                closeDropdown();
            } },
            item.img && (React.createElement(PreloadedImage, { className: "left-image", src: item.img, alt: item.imgBackup })),
            React.createElement("div", { className: "item-label" }, item.label),
            onDelete && canDelete && !isSelected && (React.createElement(SVGIcon, { className: "right-action-icon", icon: SVGIcons.SELECT_DELETE, onClick: (event) => handleDeleteClick(event) })),
            isSelected && (React.createElement(SVGIcon, { icon: SVGIcons.SELECT_ACTIVE, className: "active-icon" }))),
        !isLast && React.createElement(Separator, { type: 'horizontal' })));
}
